function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30804",
  "data-name": "Group 30804"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5222",
  "data-name": "Rectangle 5222",
  width: 24,
  height: 24,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30806",
  "data-name": "Group 30806"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_30805",
  "data-name": "Group 30805"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59680",
  "data-name": "Path 59680",
  d: "M3,11H3a2.006,2.006,0,0,0-2,2v7a2.006,2.006,0,0,0,2,2H3a2.006,2.006,0,0,0,2-2V13A2.006,2.006,0,0,0,3,11Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59681",
  "data-name": "Path 59681",
  d: "M10,5.3A3.265,3.265,0,0,1,13.3,2,3.617,3.617,0,0,1,16,3.25,3.617,3.617,0,0,1,18.7,2,3.265,3.265,0,0,1,22,5.3c0,2.1-2.5,4.51-5.33,7.09a1,1,0,0,1-1.35,0C12.5,9.81,10,7.4,10,5.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59682",
  "data-name": "Path 59682",
  d: "M19.99,17H13.16a.96.96,0,0,1-.33-.06l-1.47-.51a.49.49,0,0,1-.3-.63h0a.493.493,0,0,1,.64-.3l1.12.43a1.1,1.1,0,0,0,.36.07h2.63a1.182,1.182,0,0,0,1.18-1.18h0a1.2,1.2,0,0,0-.77-1.11L9.3,11.13A1.851,1.851,0,0,0,8.6,11H7v9.02l6.37,1.81a1.981,1.981,0,0,0,1.25-.05L22,19h0A2,2,0,0,0,19.99,17Z"
})));

function SvgVolunteerActivism(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "volunteer_activism_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteerActivism);
export default __webpack_public_path__ + "static/media/volunteer_activism.06846062.svg";
export { ForwardRef as ReactComponent };